export default __webpack_public_path__ + "static/media/img-600x400-3.b794075d.jpg";